export const stringConstants = {
    PA_CHECK_FORM_URL: 'prior-authorization-lookup',
    PA_CHECK_RESULTS_URL: 'prior-authorization-lookup-results',
}